import React from "react";
import { MapPin, Clock, BadgeCheck, Zap } from "lucide-react";

const ITEMS = [
  {
    icon: MapPin,
    title: "Experiencia local",
    text: "Conocemos el corredor industrial de Saltillo, Ramos Arizpe y Arteaga: tiempos, accesos y normativas.",
  },
  {
    icon: Clock,
    title: "Soporte 24/7",
    text: "Mesa de servicio operando los 365 días con SLAs definidos para sitios de misión crítica.",
  },
  {
    icon: BadgeCheck,
    title: "Marcas certificadas",
    text: "Partners autorizados de las principales marcas mundiales en seguridad, redes y climatización.",
  },
  {
    icon: Zap,
    title: "Respuesta rápida",
    text: "Cuadrillas en sitio en menos de 4 horas dentro de la zona metropolitana de Saltillo.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="porque"
      data-testid="why-us-section"
      className="relative py-24 lg:py-32 border-t border-white/10"
    >
      <div className="absolute inset-0 grid-overlay opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6 reveal">
            <span className="section-tag">03 / Diferenciadores</span>
            <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-[56px] tracking-tight leading-[0.98]">
              ¿Por qué <span className="text-[#F8BC33]">elegirnos</span>?
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4 reveal reveal-delay-1">
            <p className="text-white/65 leading-relaxed">
              Cada planta es distinta. Por eso ofrecemos atención dedicada,
              ingeniería ajustada al sitio y un equipo técnico que vive en la
              región. Sin intermediarios, sin tiempos muertos.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((it, i) => (
            <div
              key={it.title}
              data-testid={`why-item-${i}`}
              className={`bg-[#181C24] p-8 lg:p-10 hover:bg-[#212731] transition-colors group reveal ${
                i === 1
                  ? "reveal-delay-1"
                  : i === 2
                  ? "reveal-delay-2"
                  : i === 3
                  ? "reveal-delay-3"
                  : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center justify-center w-12 h-12 border border-white/15 group-hover:border-[#F8BC33] group-hover:text-[#F8BC33] transition-colors">
                  <it.icon className="w-5 h-5" strokeWidth={1.5} />
                </span>
                <span className="font-mono-tech text-xs text-white/35">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-7 font-display font-bold text-xl">
                {it.title}
              </h3>
              <p className="mt-3 text-sm text-white/60 leading-relaxed">
                {it.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
